import { render } from "./ProcessSection.vue?vue&type=template&id=3022589c&scoped=true"
import script from "./ProcessSection.vue?vue&type=script&lang=js"
export * from "./ProcessSection.vue?vue&type=script&lang=js"

import "./ProcessSection.vue?vue&type=style&index=0&id=3022589c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3022589c"]])

export default __exports__